import { render } from "./LimitedEditPopup.vue?vue&type=template&id=146801dc&ts=true"
import script from "./LimitedEditPopup.vue?vue&type=script&lang=ts"
export * from "./LimitedEditPopup.vue?vue&type=script&lang=ts"

import "./LimitedEditPopup.vue?vue&type=style&index=0&id=146801dc&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__